export const DECLINE_BUTTON_ARIA_LABEL = 'Decline item';
export const APPROVE_BUTTON_ARIA_LABEL = 'Approve item';
